import { useState, useCallback } from 'react';
import { Drawer, DrawerBody, Icon } from '@customerio/pluma-components/react';
import { IconButton } from '../icon-button';

export function NotificationsDrawer(props?: { isNewLayout?: boolean }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <IconButton
        icon={props?.isNewLayout === true ? undefined : 'notifications'}
        label="Notifications"
        onClick={handleOpen}
        isNewLayout={props?.isNewLayout}
      >
        {props?.isNewLayout === true ? <Icon name="notifications" size="md" style={{ marginInline: '-2px' }} /> : null}
      </IconButton>

      <Drawer isOpen={isOpen} onClose={handleClose} title="Notifications" placement="right" size="sm">
        <DrawerBody />
      </Drawer>
    </>
  );
}
